"use client"
import BuildingStorefrontIcon from "@heroicons/react/24/solid/BuildingStorefrontIcon";
import MapPinIcon from "@heroicons/react/24/solid/MapPinIcon";
import UserIcon from "@heroicons/react/24/solid/UserIcon";
import { Input } from "./Input";
import TextArea from "./TextArea";
import { Button } from "@/components/ui/button";
import { useAddVenueContext } from "@/context/AddVenueContext";
import PhoneInput from "@/components/ui/phone-input";
import { useTranslation } from "@/hooks/translationContext";
import { addVenueFormAction } from "@/actions/createVenueAction";
import { useAction } from "next-safe-action/hooks";
import SafeActionToaster from "@/components/SafeActionToaster";
import { useEffect } from "react";
import toast from "react-hot-toast";

export default function AddPlaceForm({ formId }: { formId: string }) {
    const { venueDatas, setVenueDatas } = useAddVenueContext();
    const { t } = useTranslation();
    const { execute, result, status } = useAction(addVenueFormAction);

    const updateVenueData = (field, value) => {
        setVenueDatas(prevData => ({
            ...prevData,
            [field]: value
        }));
    };

    const handleNameSurnameChange = (e) => {
        const fullName = e.target.value;
        const nameParts = fullName.split(" ");
        const lastName = nameParts.pop() || "";
        const firstName = nameParts.join(" ");

        setVenueDatas(prevData => ({
            ...prevData,
            firstname: firstName,
            lastname: lastName
        }));
    };

    useEffect(() => {
        if (status == "hasSucceeded") {
            toast.success(t("add-venue-page-register-success"))
        }
    }, [status])

    return (
        <form action={execute}>
            <SafeActionToaster result={result} status={status} />

            <div className="flex flex-col gap-4 pt-3 items-center">
                <Input
                    name="venueName"
                    value={venueDatas.name}
                    maxLength={60}
                    focusDisabled={true}
                    onChange={(e) => updateVenueData("name", e.target.value)}
                    placeholder={t("add-venue-page-venue-name-placeholder")}
                    id={"venueName"}
                    icon={<BuildingStorefrontIcon className="size-5" />}
                />

                <TextArea
                    focusDisabled={true}
                    name="venueAddress"
                    value={venueDatas.address}
                    onChange={(e) => updateVenueData("address", e.target.value)}
                    placeholder="Adres"
                    id={"venueAddress"}
                    icon={<MapPinIcon className="size-5" />}
                />
            </div>

            <div className="pt-4 flex flex-col items-center gap-4">
                <Input
                    focusDisabled={true}
                    name="nameAndSurname"
                    maxLength={100}
                    onChange={handleNameSurnameChange}
                    placeholder={t("add-venue-page-fullname-placeholder")}
                    id={"nameAndSurname"}
                    icon={<UserIcon className="size-5" />}
                />

                <PhoneInput
                    id="phoneNumber"
                    name="phoneNumber"
                    value={venueDatas.phone}
                    setValue={(value) => updateVenueData("phone", value)}
                />

                <Button
                    type="submit"
                    className="py-2 w-full text-white bg-[#15BBAE] text-sm font-bold hover:bg-[#15BBAE]"
                >
                    {t("venue-add-title", {
                        defaultValue: "Mekan Ekle",
                    })}
                </Button>
            </div>
        </form>
    )
}